import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TMachineServiceState } from './machine-service.models';

export const getMachineServiceState = (state: TMachineMaintenanceState) => state.machineServiceInfo;

export const getMachineServiceListingInfo = createSelector(
  getMachineServiceState,
  (state: TMachineServiceState) => state.machineServiceListingInfo,
);

export const getPagination = createSelector(
  getMachineServiceState,
  (state: TMachineServiceState) => state.machineServiceListingPagination,
);
